export const listEdgeDevices = async (sessionToken) => {
  const response = await fetch(
    `https://5lpvkiuz0f.execute-api.us-east-1.amazonaws.com/v1/edge/listEdgeDevices`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionToken,
      },
    }
  );
  return await response.json();
};